import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-lg modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  class: "alert alert-warning text-dark",
  role: "alert"
}
const _hoisted_9 = {
  key: 0,
  class: "card"
}
const _hoisted_10 = { class: "card-header" }
const _hoisted_11 = { class: "list-group list-group-flush" }
const _hoisted_12 = { class: "text-primary" }

import { computed, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { DependentEntityInfo } from "@common/types"
    import type { WeightsSetDependenciesViewerViewModel } from "@Criteria/Weights/Components/WeightsSetDependenciesViewer"
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes"
    import { useRoute } from 'vue-router'

    // ---------------- props ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WeightsSetDependenciesViewer',
  props: {
        viewModel: {
            type: Object as PropType<WeightsSetDependenciesViewerViewModel>,
            required: true
        }
    },
  setup(__props) {

    const props = __props

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')
    const route = useRoute()

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const initialized = computed(() => vm.value.initialized)

    const weightsSetName = computed(() => vm.value.weightsSetName)
    const dependenciesCount = computed(() => vm.value.dependenciesCount)
    const weightedScores = computed<DependentEntityInfo[]>(() => vm.value.weightedScores)

    // ---------------- helpers ----------------

    function url_EditWeightedScorePage(e: DependentEntityInfo)
    {
        return dynamicUiRoutes.Criteria_EditWeightedScorePage2(
            route,
            e.WorkspaceId,
            e.TchProjectId,
            Number.parseInt(e.Id)
        )
    }

    // ---------------- actions ----------------

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Weights set dependencies", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Checking dependencies... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, [
                          _cache[2] || (_cache[2] = _createTextVNode(" The weights set '", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(weightsSetName.value), 1 /* TEXT */),
                          _cache[3] || (_cache[3] = _createTextVNode("' is used in ", -1 /* CACHED */)),
                          _createElementVNode("strong", null, _toDisplayString(dependenciesCount.value), 1 /* TEXT */),
                          _cache[4] || (_cache[4] = _createTextVNode(" places. ", -1 /* CACHED */))
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        (weightedScores.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _cache[5] || (_cache[5] = _createTextVNode(" Weighted scores (", -1 /* CACHED */)),
                                _createElementVNode("span", null, _toDisplayString(weightedScores.value.length), 1 /* TEXT */),
                                _cache[6] || (_cache[6] = _createTextVNode(") ", -1 /* CACHED */))
                              ]),
                              _createElementVNode("ul", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weightedScores.value, (ws) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    class: "list-group-item",
                                    key: ws.Id
                                  }, [
                                    _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [
                                      _createTextVNode(_toDisplayString(ws.Name), 1 /* TEXT */)
                                    ])), [
                                      [_directive_sanitizedHref, url_EditWeightedScorePage(ws)]
                                    ])
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]))
                          : _createCommentVNode("v-if", true)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})